import { useEffect, useState } from "react";

const Q = "(max-width: 767px)";

/* <768px 视为手机（与 Tailwind md 断点一致） */
export function useIsMobile() {
  const [m, setM] = useState(() => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(Q).matches : false));
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(Q);
    const h = (e) => setM(e.matches);
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, []);
  return m;
}
